import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskOffice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconDeskOffice"><Path d="M2.75 18.25V8.75C2.75 7.09315 4.09315 5.75 5.75 5.75H11.25M11.25 5.75H18.25C19.9069 5.75 21.25 7.09315 21.25 8.75V18.25H11.25V5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M14.75 9.75V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconDeskOffice;
